import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  ButtonToolbar,
  Modal,
  Schema,
  Loader,
  Container,
  Content,
} from "rsuite";
import { Form, Field } from "react-final-form";
import { UserServices } from "../../../core/services/UserServices";
import { UtilityServices } from "../../../core/services/UtilityServices";
import { HelperServices } from "../../../core/services/HelperServices";
import CustomSelector from "../../shared/customSelector";
import {
  getImageForTheme,
  isEmptyVal,
  isNotNull,
} from "../../../utils/helpers";
import { useNavigate } from "react-router-dom";
import {
  httpStatusArr,
  messageTypeArr,
} from "../../../core/config/AppConstants";
import { useTranslation } from "react-i18next";
import { get } from "lodash/fp";

const UpdateTheme = (props: any): any => {
  const { t } = useTranslation();
  const fromRef = useRef<any>();
  const navigate = useNavigate();
  const [loader, setLoading] = useState(false);
  const [themeImage, setThemeImage] = useState("");
  const [themeList, setThemeList] = useState([]);

  const [patternError, setPatternError] = useState("");
  const [formData, setFormData] = useState<any>({
    admin_theme: "",
    setting_for: "theme",
  });

  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    init();
  }, []);

  async function init() {
    try {
      setLoading(true);
      const res = await HelperServices.getAllAdminThemes();
      const respThemeData = get("data.data", res);
      setThemeList(respThemeData);

      const response: any = await UserServices.getUserSettings();
      const respData = get("data.data", response);
      let obj = { ...formData };
      const intFields = ["admin_theme"];
      Object.keys(obj).map((formKey) => {
        if (intFields.includes(formKey) && respData[formKey]) {
          obj[formKey] = parseInt(respData[formKey]);
        } else if (respData[formKey]) {
          obj[formKey] = respData[formKey];
        }
      });

      if (!isEmptyVal(obj["admin_theme"])) {
        setThemeImage(getImageForTheme(obj["admin_theme"], respThemeData));
      }

      setFormData({ ...obj });
      setLoading(false);
    } catch (error: any) {
      UtilityServices.showToaster({
        message: error.message,
        type: messageTypeArr.error,
      });
      navigate(-1);
    }
  }

  function handleThemeChange(themeId: any, form?: any) {
    if (form) {
      form.change("admin_theme", themeId);
      setThemeImage(getImageForTheme(themeId, themeList));
    }
  }

  function clearAdminTheme(form?: any) {
    form.change("admin_theme", "");
    setThemeImage("");
  }

  const onSubmit = (val: any) => {
    const form = new FormData();
    for (var key in formData) {
      if (isNotNull(val[key])) form.append(key, val[key]);
    }
    saveUserSetting(form);
  };

  async function saveUserSetting(form: any) {
    try {
      setLoading(true);
      let response: any;
      response = await UserServices.updateSettings(form);
      setLoading(false);
      UtilityServices.showToaster({
        message: response?.data?.message,
      });
      navigate(-1);
    } catch (error: any) {
      setLoading(false);
      UtilityServices.showToaster({
        message: error?.message,
        type: messageTypeArr.error,
      });
      setErrorMessage(error?.message);
    }
  }

  return (
    <div className="modal-container">
      {loader && (
        <Loader
          style={{ zIndex: 9999 }}
          size="lg"
          backdrop
          content={t("LOADING")}
          vertical
        />
      )}
      <Modal
        open={true}
        backdrop="static"
        onClose={(e: any) => {
          setPatternError("");
          setFormData({});
          navigate(-1);
        }}
        size="sm"
      >
        <Modal.Header>
          <Modal.Title className="mb-2">
            <b>
              {t("UPDATE")} {t("THEME")}
            </b>
            <br />
            <span style={{ fontSize: "12px" }}>
              ({t("CHANGE_SETTING_NOTE")})
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="pb-0 mt-3">
          <Container>
            <Content className="content customer-create-wrap mb-0">
              <Form
                onSubmit={onSubmit}
                validate={(values: any) => {
                  const errors: any = {};
                  return errors;
                }}
                initialValues={{ ...formData }}
                render={({ handleSubmit, form }) => (
                  <form onSubmit={handleSubmit}>
                    <div className="form-part">
                      <div className="flex-container">
                        <Field name="admin_theme">
                          {({ input, meta }) => (
                            <div className="flex-item col-md-4 col-4">
                              <CustomSelector
                                loaderMsg={t("FETCHING_DATA_OF", {
                                  field:
                                    t("ADMIN").toLocaleLowerCase() +
                                    " " +
                                    t("THEME").toLocaleLowerCase(),
                                })}
                                isRequired={false}
                                valueKey="id"
                                labelKey="theme_title"
                                isDisable={!themeList?.length ? true : false}
                                labelName={t("THEME")}
                                defaultValue={input.value}
                                onClear={(event: any) => {
                                  clearAdminTheme(form);
                                }}
                                listData={themeList}
                                onSelect={(e: any, selectedObj: any) => {
                                  handleThemeChange(e, form);
                                }}
                              />
                              {meta.error && meta.touched && (
                                <span>{meta.error}</span>
                              )}
                            </div>
                          )}
                        </Field>
                        <ButtonToolbar className="text-center d-flex btn-theme mb-1 col-md-4">
                          <Button
                            appearance="primary"
                            type="submit"
                            loading={loader}
                          >
                            {t("UPDATE")}
                          </Button>
                          <Button
                            onClick={(e: any) => {
                              clearAdminTheme(form);
                              navigate(-1);
                            }}
                            color="red"
                            appearance="primary"
                          >
                            {t("CANCEL")}
                          </Button>
                        </ButtonToolbar>
                      </div>
                    </div>

                    {themeImage && (
                      <div>
                        <div className="view-prd-profile text-center">
                          <div>
                            <img src={themeImage} alt="" />
                          </div>
                        </div>
                      </div>
                    )}
                  </form>
                )}
              />
            </Content>
          </Container>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default UpdateTheme;
